module.exports = "/call-frontend/img/icon_link_outline.f9756a76.svg";